export default __webpack_public_path__ + "static/media/screen2.c6e7324a.png";